import { describeSectionFailure } from './describeSectionFailure'
import type { SectionValidation } from './types'

interface ValidationBadgeProps {
  validated: boolean
  failingSections: SectionValidation[]
}

// Green when every checkable section summed to its printed total, amber otherwise.
export const ValidationBadge = ({
  validated,
  failingSections,
}: ValidationBadgeProps) => {
  if (validated) {
    return (
      <span className="inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">
        Validated
      </span>
    )
  }

  const detail = failingSections[0]
    ? describeSectionFailure(failingSections[0])
    : undefined

  return (
    <div className="flex flex-col items-start gap-0.5">
      <span className="inline-flex w-fit items-center rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">
        Needs review
      </span>
      {detail && (
        <p className="max-w-[220px] text-xs text-muted-foreground">{detail}</p>
      )}
    </div>
  )
}
